import { render, staticRenderFns } from "./ClienteNew.vue?vue&type=template&id=8e5f2982"
import script from "./ClienteNew.vue?vue&type=script&lang=ts"
export * from "./ClienteNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports